import { CSSProperties } from 'react';
import styled from 'styled-components';

import { DeepPartial } from '@bodilenergy/util';
import { BodilColor } from '~src/branding';
import { Heading, Text } from '~src/components/Typography';
import { OfferProducts } from '~src/graphql';
import { useDisplay } from '~src/hooks/useDisplay';

import { USPEntries } from './USPEntries';

type SuggestionBannerProps = {
  style?: CSSProperties;
  products?: DeepPartial<OfferProducts>;
};

const SuggestionBannerWrapper = styled.div<{ style?: CSSProperties; isMobile?: boolean }>(({ style, isMobile }) => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  ...(isMobile ? { flexDirection: 'column', gap: '24px' } : { height: '180px' }),
  backgroundColor: BodilColor.base.default,
  ...style,
}));

const ProductsWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  minWidth: '200px',
});

const ProductWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const ProductText = styled(Text)({
  lineHeight: '20px',
  marginTop: '8px',
});

export const SuggestionBanner = ({ products, style }: SuggestionBannerProps) => {
  const { isMobile } = useDisplay();

  const { solarPanel, inverter, battery, heatPumpOutdoorUnit, heatPumpIndoorUnit } = products ?? {};

  return (
    <SuggestionBannerWrapper style={style} isMobile={isMobile}>
      <div style={{ ...(isMobile && { alignItems: 'start', width: '100%' }) }}>
        {(!!solarPanel || !!heatPumpOutdoorUnit) && (
          <Heading level={2} color='light'>
            Bodil foreslår
          </Heading>
        )}

        <ProductsWrapper>
          {!!solarPanel && (
            <ProductWrapper>
              <ProductText level={2} color='light'>
                {((solarPanel.annualProduction ?? 0) * (solarPanel.quantity ?? 1)) / 1000} kWp {solarPanel.brand}
              </ProductText>
              <ProductText level={2} color='light'>
                {inverter?.brand} inverter
              </ProductText>
              <ProductText level={2} color='light'>
                {battery?.capacity} kWh {battery?.brand} batteri
              </ProductText>
              {battery?.brand?.trim() === 'Solplanet' && (
                <ProductText level={2} color='light'>
                  AI Styring med intellicharge
                </ProductText>
              )}
            </ProductWrapper>
          )}

          {!!heatPumpOutdoorUnit && (
            <ProductWrapper>
              <ProductText level={2} color='light'>
                {heatPumpOutdoorUnit?.brand} udedel
              </ProductText>
              <ProductText level={2} color='light'>
                {heatPumpIndoorUnit && heatPumpIndoorUnit?.brand + ' indedel'}
              </ProductText>
            </ProductWrapper>
          )}
        </ProductsWrapper>
      </div>

      <USPEntries />
    </SuggestionBannerWrapper>
  );
};
